import { setHLFCookies, removeHLFCookies } from '@client/tracking/collector.js';

export const cookieConsent = () => {
  const cookiebotExists = typeof Cookiebot !== 'undefined';
  if (cookiebotExists) return Cookiebot?.consent; // eslint-disable-line

  if (!cookiebotExists)
    return {
      necessary: true,
      marketing: null,
      preferences: null,
      statistics: null,
    };
};

export const setStatisticsAndMarketingCookies = () => {
  setHLFCookies();
};

export const noStatistics = () => {
  removeHLFCookies();
};

export const noMarketing = () => {
  removeHLFCookies();
};

export const cookiebotOnConsentReady = () => {
  if (typeof window !== 'undefined') {
    window.addEventListener('CookiebotOnConsentReady', () => {
      const { statistics, marketing } = cookieConsent();
      // if (statistics) { ... }
      // if (marketing) { ... }
      if (statistics && marketing) setStatisticsAndMarketingCookies();

      if (!statistics) noStatistics();
      if (!marketing) noMarketing();
    });
  }
};
